export default {"src":"/_next/static/media/smartphone-charging.f2844d7e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};